export default __webpack_public_path__ + "static/media/uploader-roche-4.ac8dcb8b.png";